module.exports = __webpack_public_path__ + "img/Total Protein Biuret.2 (mid).cdada6ad.jpg";